<template>
  <el-tooltip
      :effect="effect"
      :disabled="!isShowTooltip"
      :content="content"
      :open-delay="opendelay"
      :placement="placement">
    <div class="tooltip-root" ref="container" @mouseover="onMouseOver"  >
      <slot></slot>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'ShowOverflowTooltip',
  props: {
    effect: { //主题
      type: String,
      default: 'dark',
    },
    text: {
      type: String,
      default: '',
    },
    placement: { //位置
      type: String,
      default: 'top',
    },
    opendelay:{  //延迟
      type:Number,
      default:0
    },
    ellipsis:{ //是否显示...
      type:Boolean,
      default:true
    },
    maxWidth:{ //最大宽度
      type:String,

    },
    tooltip:{//是否显示提示框
      type:Boolean,
      default:true
    }
  },
  watch:{
    text:function(val,oldval){
      if(val&&val!==oldval){
        this.isContainerSqueezed()
      }
    }

  },

  data() {
    return {
      isShowTooltip: false,
      content: '',
    };
  },
  mounted() {
    this.isContainerSqueezed()
  },
  // updated() {
  //   const { container } = this.$refs;
  //
  //   if(this.maxWidth&&container.innerText){
  //     this.isContainerSqueezed();
  //   }
  // },

  // computed:{
  //
  // },
  // watch:{
  //
  // },
  methods: {
    onMouseOver() {
      // console.log('cccccccccc')
       this.isContainerSqueezed();
    },
    isContainerSqueezed() {
      //根据配置，判断是否显示省略号,为true的时候，不做处理，false的时候，改变一下属性值
      if(!this.ellipsis){
        this.$refs.container.style.textOverflow='clip'
      }
      //根据配置，是否显示提示框
      if(this.tooltip){
        const { container } = this.$refs;
        if (!container) {
          this.isShowTooltip = false;
        }else{

        this.isShowTooltip = container.scrollWidth !== container.clientWidth;
        if(this.maxWidth){
          let showTooltip = container.scrollWidth >= this.maxWidth;
          if(container.innerText &&container.innerText.length<6) {
            showTooltip =false
          }
          if(this.text && container.innerText.length<13){
            showTooltip =false
          }
          this.isShowTooltip = showTooltip;
          if (showTooltip) {
            container.style.width = this.maxWidth+'px'
          }
        }
        this.content = container.innerText;
        }

      }
      else{
        this.isShowTooltip = false
      }
    },
    // // 响应点击事件
    // clickHandle(){
    //   this.$emit('click')
    // },
  },
};
</script>

<style scoped lang="scss">
.tooltip-root {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
  //display: inline-flex;

}
</style>



// WEBPACK FOOTER //
// src/components/ShowOverfLowTooltip.vue